import { IKnmListFilter } from '../interfaces/IKnmListFilter';

export const initialKnmListFilter: IKnmListFilter = {
  name: 'Новый фильтр',
  years: [],
  includeDomainChild: false,
  ignoreKno: false,
  includeChildKno: false,
};
